// Alert Surface enum (matches API response)
export enum EAlertSurface {
  WEB = "WEB",
  ANDROID = "ANDROID",
  IOS = "IOS",
}

// Alert Severity enum (matches API response)
export enum EAlertSeverity {
  INFO = "INFO",
  WARNING = "WARNING",
  CRITICAL = "CRITICAL",
}

// Alert Status enum (matches API response)
export enum EAlertStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

// CTA interface
export interface IAlertCta {
  enabled: boolean;
  label?: string;
  url?: string;
}

// Alert interface (matches actual API response structure)
export interface IAlert extends Record<string, unknown> {
  id: string; // Changed to string to match API response
  messageAr: string;
  cta: IAlertCta; // Changed to nested object structure
  severity: EAlertSeverity;
  surfaces: EAlertSurface[];
  status: EAlertStatus;
  createdAt: string;
  updatedAt: string;
}

// API Response for alerts list (matches actual API structure)
export interface IAlertsListResponse {
  status: number;
  timestamp: string;
  data: {
    alertWidgetDTOs: IAlert[];
  };
}

// API Response for single alert (matches actual API structure)
export interface IAlertResponse {
  status: number;
  timestamp: string;
  data: IAlert;
}

// Alert creation/update body (matches API expectations)
export interface ICreateAlertBody {
  messageAr: string;
  ctaEnabled: boolean;
  ctaLabel?: string;
  ctaUrl?: string;
  severity: EAlertSeverity;
  surfaces: EAlertSurface[];
}

export interface IUpdateAlertBody {
  id: string;
  messageAr: string;
  ctaEnabled: boolean;
  ctaLabel?: string;
  ctaUrl?: string;
  severity: EAlertSeverity;
  surfaces: EAlertSurface[];
}

// Alert API parameters
export interface IAlertsParams {
  page?: number;
  size?: number;
  sort?: string;
  searchKeyWord?: string;
  status?: EAlertStatus;
  severity?: EAlertSeverity;
  surface?: EAlertSurface;
}
